import {
  IEmployeeProfileForm,
  TDealerFormItem,
  TPositionFormItem,
} from "./types";

export const POSITION_NUMBERS = ["one", "two", "three", "four"] as const;

export const getNextPositionSlotIndex = (
  positions: TPositionFormItem[],
): number | null => {
  const usedNumbers = new Set(positions.map((position) => position.number));
  const nextNumber = POSITION_NUMBERS.find(
    (number) => !usedNumbers.has(number),
  );

  if (!nextNumber) {
    return null;
  }

  return POSITION_NUMBERS.indexOf(nextNumber);
};

export const defaultValueDealer = (): TDealerFormItem => ({
  dealer: null,
  organizationType: "DEALER",
  email: "",
  emailVerification: false,
  dataConsentId: "",
  status: "",
  lastStatusUpdateAt: "",
  lastStatusUpdateByUser: "",
  positionOrderId: "",
  startDate: null,
  startOrderNumber: "",
  hired: "",
  endDate: null,
  endOrderNumber: "",
  dismissalOrderId: "",
  jobDescriptionId: "",
});

export const defaultValuePosition = (index: number): TPositionFormItem => ({
  number: POSITION_NUMBERS[index] ?? "four",
  position: null,
  licenseAssigned: false,
  licenseFreeCount: 0,
  dealers: [defaultValueDealer()],
  isNew: true,
});

export const getDefaultFormValues = (): IEmployeeProfileForm => ({
  name: "",
  surname: "",
  middleName: "",
  noMiddleName: false,
  gender: "Male",
  birthDay: null,
  workPhone: "",
  photoId: "",
  ladaAcademiaId: "",
  resourcesControlUserId: "",
  createdAt: null,
  lastEditDate: null,
  hiredDate: null,
  positions: [defaultValuePosition(0)],
});
